import React from 'react';
import { FacilityAdditionalContactEditTemplate } from 'themes/application/facility/components';
import { observer } from 'mobx-react';
import { FacilityAdditionalContactEditViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';
@setCurrentView((rootStore, componentProps) => new FacilityAdditionalContactEditViewStore(rootStore, componentProps), 'facilityAdditionalContactEditView')
@observer
class FacilityAdditionalContactEdit extends React.Component {
    render() {
        return <FacilityAdditionalContactEditTemplate {...this.props} />
    }
}

export default FacilityAdditionalContactEdit;